export default __webpack_public_path__ + "static/media/Layer 2.22d48b24.svg";